<template>
    <div v-if="aulaReposicao.id" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes da Aula de Reposição nº {{ aulaReposicao.id }}</h4>
        <button class="btn btn-secondary" @click="voltar">Voltar</button>
      </div>
      <p></p>
      <!-- Dados do Aluno e Observações -->
      <FormSection title="Dados do Aluno e Observações">
        <div class="info-group">
          <strong>Aluno:</strong> {{ aulaReposicao.aluno_nome || '-' }}
        </div>
        <div class="info-group">
          <strong>Observações:</strong> {{ aulaReposicao.observacoes || '-' }}
        </div>
      </FormSection>
  
      <!-- Dados da Requisição -->
      <FormSection title="Dados da Requisição">
        <div class="info-group">
          <strong>Data da Requisição:</strong> {{ globalUtils.formatarData(aulaReposicao.data_requisicao) }}
        </div>
        <div class="info-group">
          <strong>Data da Aula:</strong> {{ globalUtils.formatarData(aulaReposicao.data_aula) }}
        </div>
        <div class="info-group">
          <strong>Nível:</strong> {{ nivelNome || '-' }}
        </div>
        <div class="info-group">
          <strong>Turma:</strong> {{ aulaReposicao.turma_completa || '-' }}
        </div>
      </FormSection>
    </div>
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import { reactive, onMounted,ref, computed } from "vue";
  import { useRouter, useRoute } from "vue-router";
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  import globalUtils from "@/utils/globalUtils";
  
  export default {
    components: { FormSection },
    setup() {
      const router = useRouter();
      const route = useRoute();
      const aulaReposicao = reactive({});
      const niveis = ref([]);

      const carregarNiveis = async () => {
        try {
            const response = await axios.get("/cadastros/niveis-turmas");
            // Ajuste conforme a estrutura retornada pela sua API
            niveis.value = response.data.data || response.data;
        } catch (error) {
            console.error("Erro ao carregar níveis:", error);
        }
      };

      const nivelNome = computed(() => {
        const nivel = niveis.value.find(n => n.id === aulaReposicao.nivel_id);
        return nivel ? nivel.nivel : "-";
      });

      const voltar = () => {
        router.push("/operacional/aulas-reposicao");
      };
  
      const carregarAulaReposicao = async (id) => {
        try {
          const response = await axios.get(`/operacional/aulas-reposicao/${id}`);
          Object.assign(aulaReposicao, response.data);
        } catch (error) {
          console.error("Erro ao carregar aula de reposição:", error);
        }
      };
  
      onMounted(async () => {
        await carregarNiveis();
        if (route.params.id) {
          await carregarAulaReposicao(route.params.id);
        }
      });
  
      return {
        aulaReposicao,
        voltar,
        globalUtils,
        nivelNome,

      };
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
  }
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  .info-group {
    margin-bottom: 10px;
  }
  </style>
  